export enum PasswordRequirement {
  lowerCase = 'password-lower',
  upperCase = 'password-upper',
  // eslint-disable-next-line id-blacklist
  number = 'password-number',
  specialCharacter = 'password-special',
  length = 'password-length',
  oldPassword = 'old-password-match',
}
